export default "__VITE_ASSET__W4G7wW3V__"